import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { useParams } from "react-router";

export const useSmartLink = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);
  const [dataAnl, setDataAnl] = useState<any>(null);
  const [presetData, setPresetData] = useState()

  const getToken = () =>
    localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM || "token");

  useEffect(() => {
    getSmartLinks();
  }, []);
const {id} = useParams() 
  


const getSmartLinks = async (
  page = 1,
  perPage = 10,
  filters: {
    artist_ids?: number[];
    role_ids?: number[];
    create_date_from?: string;
    create_date_to?: string;
    ean_upc?: string;
    isrc?: string;
    label_id?: number;
    platform_ids?: number[];
    release_date_from?: string;
    release_date_to?: string;
    release_title?: string;
    sort?: string;
    status?: string;
  } = {}
) => {
  try {
    console.log("Fetching Smart Links...", { page, perPage, filters }); // ✅ debug
    setLoading(true);
    setError(null);

    const token = getToken();
    if (!token) {
      throw new Error("Authorization token is missing.");
    }

    // ✅ Clean undefined/empty filter fields
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(
        ([_, v]) =>
          v !== undefined &&
          v !== null &&
          v !== "" &&
          !(Array.isArray(v) && v.length === 0)
      )
    );

    // ✅ Build full URL
    const url = `${API_BASE_URL}${API_URLS.smartLink}`;
    console.log("Request URL:", url);

    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        page,
        per_page: perPage,
        ...cleanFilters,
      },
    });

    const { data: items, meta } = response.data;

    setData(items);
    return { data: items, total: meta?.total || 0 };
  } catch (err: any) {
    console.error("Smart Links fetch error:", err);
    setError(err.response?.data?.message || err.message);
    throw err;
  } finally {
    setLoading(false);
  }
};


  const createSmartLink = async (payload: any) => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.post(
        `${API_BASE_URL}${API_URLS.smartLink}`,
        payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );

      setData((prev: any[] | null) =>
        Array.isArray(prev) ? [response.data, ...prev] : [response.data]
      );

      return response.data;
    } catch (err: any) {
      console.error("Smart Link creation error:", err);
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteSmartLink = async (id: string | number) => {
    try {
      setLoading(true);
      setError(null);

      const url = API_URLS.smartLinkDelete.replace(
        "{smart_link}",
        String(id)
      );
      await axios.delete(`${API_BASE_URL}${url}`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });

      // Ջնջում ենք state-ից
      setData((prev: any) =>
        Array.isArray(prev) ? prev.filter((item) => item.id !== id) : prev
      );
    } catch (err: any) {
      console.error("Smart Link deletion error:", err);
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const updateSmartLink = async (id: string | number, payload: any) => {
    try {
      setLoading(true);
      setError(null);

      const url = API_URLS.smartLinkDelete.replace("{smart_link}", String(id));
      const response = await axios.put(`${API_BASE_URL}${url}`, payload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });

      setData((prev: any[] | null) =>
        Array.isArray(prev)
          ? prev.map((item) =>
              item.id === id ? response.data : item
            )
          : prev
      );

      return response.data;
    } catch (err: any) {
      console.error("Smart Link update error:", err);
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const getAnalyticsOverview = async (
    smartLinkId: string | number,
    range:
      | string
      | { from?: string; to?: string; preset?: string } = { preset: "last_week" }
  ) => {
    try {
      setLoading(true);
      setError(null);

      const url = `${API_BASE_URL}${API_URLS.smartLinksOverview.replace(
        "{smart_link}",
        String(smartLinkId)
      )}`;

      let params: Record<string, any> = {};

      if (typeof range === "string") {
        params.range = [range];
      } else if (range.from && range.to) {
        params.range = [range.from, range.to];
      } else if (range.preset) {
        params.range = [range.preset];
      } else {
        params.range = ["last_week"];
      }
      
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        params,
      });

      const analyticsData = response.data?.data ?? null;
      setDataAnl(analyticsData);

      
      return analyticsData;
    } catch (err: any) {
      console.error("Smart Link analytics fetch error:", err);
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };
  const getAnalyticsTimeseries = async (
    smartLinkId: string | number,
    range:
      | string
      | { from?: string; to?: string; preset?: string } = { preset: "last_week" }
  ) => {
    try {
      setLoading(true);
      setError(null);

      const url = `${API_BASE_URL}${API_URLS.smartLinksTimeseries.replace(
        "{smart_link}",
        String(smartLinkId)
      )}`;

      let params: Record<string, any> = {};

      if (typeof range === "string") {
        params.range = [range];
      } else if (range.from && range.to) {
        params.range = [range.from, range.to];
      } else if (range.preset) {
        params.range = [range.preset];
      } else {
        params.range = ["last_week"];
      }
      
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        params,
      });

      const analyticsData = response.data?.data ?? null;
      return analyticsData;
    } catch (err: any) {
      console.error("Smart Link analytics fetch error:", err);
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  


  const getAnalyticsCountries = async (
    smartLinkId: string | number,
    range:
      | string
      | { from?: string; to?: string; preset?: string } = { preset: "last_week" }
  ) => {
    try {
      setLoading(true);
      setError(null);

      const url = `${API_BASE_URL}${API_URLS.smartLinksCountries.replace(
        "{smart_link}",
        String(smartLinkId)
      )}`;

      let params: Record<string, any> = {};

      if (typeof range === "string") {
        params.range = [range];
      } else if (range.from && range.to) {
        params.range = [range.from, range.to];
      } else if (range.preset) {
        params.range = [range.preset];
      } else {
        params.range = ["last_week"];
      }
      
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        params,
      });

      const analyticsData = response.data?.data ?? null;
      return analyticsData;
    } catch (err: any) {
      console.error("Smart Link analytics fetch error:", err);
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };



  return {
    loading,
    error,
    data,
    dataAnl,
    getSmartLinks,
    createSmartLink,
    deleteSmartLink,
    updateSmartLink,
    getAnalyticsOverview,
    getAnalyticsTimeseries,
    getAnalyticsCountries
  };
};
